export default __webpack_public_path__ + "static/media/ecommerce.bccc44b5.jpg";